export const PROFILE_CONSTS = {
    GET_USER_PROFILE: "GET_USER_PROFILE",
    GET_AUTH_CHECK: "GET_AUTH_CHECK",
    CLEAR_PROFILE: "CLEAR_PROFILE",
    SET_USER_PROFILE: "SET_USER_PROFILE",
    SET_USER_SIGNATURES: "SET_USER_SIGNATURES",
    DELETE_USER_SIGNATURES: "DELETE_USER_SIGNATURES",
    UPDATE_CONFLUINCE_INFO: "UPDATE_CONFLUINCE_INFO",
    GET_DESCRIPTORS: "GET_DESCRIPTORS"
};
